import {
    SummaryWithFormDefinitionSummaryModel
} from '../../../../../form/definition/form/api/entity/SummaryWithFormDefinitionSummary.model';
import {LovValueSummary} from "../../../../../common/lov/lov-value/api/model/lovValueSummary.model";

export class TreatmentDefinitionSummaryModel extends SummaryWithFormDefinitionSummaryModel {
    id: number;
    performedBy: LovValueSummary;
    type: LovValueSummary;
}

export const TREATMENT_FORM_DEFINITION_CONTEXT = 'FORM_CONTEXT_TREATMENT';

export enum TreatmentPerformedBy {
    TREATMENT_PERFORMED_BY_ACCOUNT = 'TREATMENT_PERFORMED_BY_ACCOUNT',
    TREATMENT_PERFORMED_BY_ACCOUNT_OTHER_PROFESSIONAL = 'TREATMENT_PERFORMED_BY_ACCOUNT_OTHER_PROFESSIONAL',
}

export enum TreatmentDefinitionType {
    TREATMENT_FORM_DEFINITION_TYPE_INSOLES = 'TREATMENT_FORM_DEFINITION_TYPE_INSOLES',
    TREATMENT_FORM_DEFINITION_TYPE_OTHER = 'TREATMENT_FORM_DEFINITION_TYPE_OTHER',
}
